import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { StepHeaderEntity } from "../../../../../entities/UIEntities/Form Entities/StepHeaderEntity";
import {
  ADD_CAMPAIGN_FORM_STEPS,
  INPUTS_PROPS,
} from "../../../../../enums/Enums";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import store from "../../../../../redux/Store";
import Icons from "../../../../../resources/icons/Icons";
import Strings from "../../../../../resources/Strings";
import classes from "../WizardForm.module.css";
import { getSitesUnderSelectedScope } from "../../../../../utils/UsersUtils";
import MultiSelectBoxInput from "../../../Inputs/CustomInputs/MultiSelectBoxInput";
import { getRecipientsSelectionEntities } from "../../../../../utils/MessagingUtils";
import { arrayNotEmpty, getErrorMessage } from "../../../../../utils/FormUtils";
import useInputInfos from "../../../../../hooks/useInputInfos";

const RecipientsStep = (props) => {
  const messagingHistories = useSelector((state) => state.messaging.messagingHistoriesData?.messagingHistories);
  const messagingHistoryToMailingLists = useSelector((state) => state.messaging.messagingHistoryToMailingLists);
  const foundedCampaignMessagingHistory = messagingHistories?.filter(mh => mh?.campaignId === props?.campaignId).sort((a, b) => new Date(b.dateSent) - new Date(a.dateSent))?.[0];

  const [recipientsSelectionEntities, setRecipientsSelectionEntities] = useState([]);
  const [foundedSelectionEntities, setFoundedSelectionEntities] = useState([]); 
  const selectedScope = useSelector((state) => state.user?.selectedScope);
  const allScopes = useSelector((state) => state.user?.allScopes);
  const sites = useSelector((state) => state.user?.sites);
  const selectedSites = getSitesUnderSelectedScope(sites, allScopes, selectedScope);
  const userTypes = useSelector((state) => state.user?.initialState?.userTypes);
  const selectedScopeUserTypes = selectedSites.map(site => userTypes.filter(ut => ut.siteId === site.id || ut.siteId === null)).flat();
  const currentScopeUsers = useSelector((state) => state.messaging.currentScopeUsers);
  const currentGmtUsers = useSelector((state) => state.user.currentGmtUsers);
  const currentUsers = currentScopeUsers.concat(currentGmtUsers);
  const mailingLists = useSelector((state) => state.messaging.mailingListsData?.mailingLists);
  const roles = useSelector((state) => state.user?.initialState)?.roles;

  const { inputInfos, handleInputInfo, getInputsStatusByInputInfos } = useInputInfos();
  const [stepHeader, setStepHeader] = useState(new StepHeaderEntity(
    Strings.STEPS_TITLES.RECIPIENTS_CAMPAIGN_TITLE,
    null,
    Icons.MESSAGING,
    null
  ));

  useEffect(() => {
    if (props.currentStep === ADD_CAMPAIGN_FORM_STEPS.RECIPIENTS) {
      store.dispatch(commonActions.setSideModal({ modalHeader: stepHeader }));
    }
  }, [props.currentStep]);

  useEffect(() => {
    if (props.currentStep === ADD_CAMPAIGN_FORM_STEPS.RECIPIENTS) {
      const { hasValue, hasError } = getInputsStatusByInputInfos(inputInfos);
      props.handleStateDataChange({["isCurrentStepValid"]: !hasError, ["isCurrentStepHasValues"]: hasValue });
    }
  }, [inputInfos]);

  
  useEffect(() => {
    // If user added recipients on current founded selections
    // save it also for when user returns with 'back button' to add again on previous selections
    setFoundedSelectionEntities(props.recipients)
  }, [props.recipients]);

  useEffect(() => {
      initAllData();
  }, []);

  const initAllData = () => {
    const recipientSelectionEntityList = getRecipientsSelectionEntities({currentScopeUsers, currentGmtUsers, selectedScopeUserTypes, mailingLists, selectedSites, roles});

    // on review mode - check if campaign was already sent, if yes retrieve the known recipients
    // and mailing lists selections (if any) from messagingHistory and auto select them
    let allFoundedCurrentSelections = [];
    if (props?.isReview) {
      // get relevant mailing list selections by messagingHistoryToMailingList, then find mailing list
      // check if selected campaign has any messagingHistoryToMailingList by messagingHistory
      let foundedCampaignMessagingHistoryToMailingList = messagingHistoryToMailingLists?.filter(mh => mh?.messagingHistoryId === foundedCampaignMessagingHistory?.id);
      
      let relevantMailingListsByMessagingHistory = mailingLists?.filter(ml => foundedCampaignMessagingHistoryToMailingList?.some(mh => mh?.mailingListId === ml?.id));   
      if (relevantMailingListsByMessagingHistory?.length > 0) {
        // if there is messagingHistoryToMailingLists, find the mailing lists selections, and diffrentiate its recipients
        // filter to prepare concat only with mailingLists that created before send, mailng lists that were updated after send wont be selected
        let foundedCurrentMailingListSelections = recipientSelectionEntityList?.filter(selection => relevantMailingListsByMessagingHistory?.filter(r =>  new Date(r.dateCreated) <= new Date(foundedCampaignMessagingHistory.dateSent))?.map(r => r.id)?.some(listId => listId === selection?.identifierId));
        
        let usersfromMailingListsRecipientsSelections = recipientSelectionEntityList?.filter(selection => relevantMailingListsByMessagingHistory?.map(r => r.mailingListToUsers)?.flat()?.some(mlto => mlto.userId === selection?.identifierId));

        // single recipients from messagingHistory
        let foundedCurrentRecipientsSelections = recipientSelectionEntityList?.filter(selection => foundedCampaignMessagingHistory?.recipients?.some(recipient => recipient?.UtronUserId === selection?.identifierId));

        // represents the remaining recipients after decrement from recipients from mailingLists 
        // (all recipients (foundedCurrentRecipientsSelections) - usersfromMailingListsRecipientsSelections)
        let remainingRecipientsSelection = foundedCurrentRecipientsSelections.filter(f => !usersfromMailingListsRecipientsSelections.some(u => f.identifierId === u.identifierId));

        allFoundedCurrentSelections = remainingRecipientsSelection.concat(foundedCurrentMailingListSelections);
      } 
      else {
        // when theres no messagingHistoryToMailing List or mailinglist (referenced to deleted one)
        // set known recipients from messagingHistory as all the recipients
        allFoundedCurrentSelections = recipientSelectionEntityList?.filter(selection => foundedCampaignMessagingHistory?.recipients?.some(recipient => recipient?.UtronUserId === selection?.identifierId));
      }
      
      // update formData's recipients
      props.handleChange({[INPUTS_PROPS.RECIPIENTS]: allFoundedCurrentSelections });

      setFoundedSelectionEntities(allFoundedCurrentSelections);
    }

    setRecipientsSelectionEntities(recipientSelectionEntityList);
  };

  if (props.currentStep !== ADD_CAMPAIGN_FORM_STEPS.RECIPIENTS) {
    return null;
  }
  
  return (
    <div className={classes.stepContainer}>
      <div className={classes.stepTitle}>
        {Strings.STEPS_TITLES.RECIPIENTS_TITLE}
      </div>
      <span className={classes.stepSubTitle}>
        {Strings.STEPS_TITLES.RECIPIENTS_SUB_TITLE}
      </span>

      <div className={classes.fileds}>
        <MultiSelectBoxInput 
          id={INPUTS_PROPS.RECIPIENTS}
          label={`${Strings.INPUT_LABELS.RECIPIENTS}*`}
          items={recipientsSelectionEntities}
          foundedItems={foundedSelectionEntities}
          showTotal={true}
          currentUsers={currentUsers}
          mailingLists={mailingLists}
          // startAdornment={<img src={Icons.SEARCH} />}
          //placeholder={'Users'}
          onItemClicked={(items) => {
            props.handleChange({[INPUTS_PROPS.RECIPIENTS]: items });
          }}
          campaignType={props.campaignType}
          isStepSubmitted={props.isStepSubmitted}
          isRequired={true}
          handleInputInfo={handleInputInfo}
          hasError={!arrayNotEmpty(props.recipients).isValid}
          errorMessage={getErrorMessage(arrayNotEmpty(props.recipients))}
        />
      </div>
    </div>
  );
};

export default RecipientsStep;
